// extracted by mini-css-extract-plugin
module.exports = {"home":"home_home__1eoyL","table":"home_table__2M7ux"};